import React from "react";
import { useChartSwitcher } from "#hooks/use-chart-switcher";
import { SvgContainer } from "#ui";
import { EBITMargin } from "./EBITMargin";
import { Earnings } from "./Earnings";
import { Sales } from "./Sales";
import { ChartProps } from "#interfaces";

const CHART_COUNT = 4;

export const EBITMarginChartDesktop: React.FC<Pick<ChartProps, "labels">> = ({ labels }) => {
  const chartProps = useChartSwitcher(CHART_COUNT);
  return (
    <SvgContainer viewBox="0 0 896 544" xmlns="http://www.w3.org/2000/svg">
      <EBITMargin labels={labels?.margin} {...chartProps} />
      <Earnings labels={labels?.earnings} {...chartProps} />
      <Sales labels={labels?.sales} {...chartProps} />
    </SvgContainer>
  );
};
